import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ConvertLoadButton = ({ materialContainerId, printerUri }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/material-container/${materialContainerId}?printer=${printerUri}`);
  };

  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div>
        Convert <i>Lot</i> to <i>Batch</i> &amp; <i>Load</i> into Printer
      </div>
      <button type='button' className='btn btn-primary btn-action' onClick={handleClick}>
        Convert + Load
      </button>
    </div>
  );
};

ConvertLoadButton.propTypes = {
  materialContainerId: PropTypes.string.isRequired,
  printerUri: PropTypes.string.isRequired,
};
